module.exports = __webpack_public_path__ + "img/asus-vivobook-x510ua.7b02a41a.jpg";